import React, {useState} from "react";
import {Autocomplete, InputAdornment, TextField} from "@mui/material";
import _ from "lodash";
import {useSelector} from "react-redux";
import I18nInputAdornmentSelect from "../i18n-input-adornment-select";
import {languageSelector} from "../../state/app/appSelectors";

const I18nAutocomplete = ({renderInputProps, ...autocompleteProps}) => {
  const defaultLanguage = useSelector(languageSelector);

  const [language, setLanguage] = useState(defaultLanguage);

  const handleChange = (_event, newValues) => {
    const res = autocompleteProps.value ? _.cloneDeep(autocompleteProps.value) : {};
    res[language] = newValues;
    autocompleteProps.onChange(res);
  };

  // Selected values of the autocomplete are stored inside the startAdornment
  // of the TextField InputProps for rendering. Using SlotProps or overwriting
  // the InputProps would prevent the rendering of the selected values.
  return (
    <Autocomplete
      {...autocompleteProps}
      value={autocompleteProps.value?.[language] || []}
      onChange={handleChange}
      renderInput={params => (
        <TextField
          {...params}
          {...renderInputProps}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <>
                <InputAdornment position="start">
                  <I18nInputAdornmentSelect value={language} onChange={lang => setLanguage(lang)} />
                </InputAdornment>
                {params.InputProps.startAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};

export default I18nAutocomplete;
